<div class="main-wrapper">

    <ngx-spinner
            bdColor="rgba(51,51,51,0.8)"
            size="medium"
            color="#fff"
            type="ball-scale-multiple"
    >
        <p style="font-size: 20px; color: white">{{'loading.moment' | translate}}</p>
    </ngx-spinner>

    <div class="row main-row">
        <div class="col-12">
            <div class="inner-wrapper">
                <div class="header">
                    <div class="flexed">
                        <img src="/assets/img/safetly logo.png">
                        <h3>{{'safetly' | translate}}</h3>
                    </div>
                </div>
                <div *ngIf="!accepted && loading" class="body">
                    <h1>{{'loading.checking-info' | translate}}</h1>
                    <h3>{{'loading.patience' | translate}}</h3>
                </div>
                <div *ngIf="accepted" class="body">
                    <h1>{{'loading.accepted' | translate}}</h1>
                    
                    <p>Please download Safetly app from store</p>
                    
                    <div class="badge-container">
                        <a href="{{playStoreUrl}}">
                            <img src="/assets/img/googleplay.png" alt="">
                        </a>
                        <a href="{{appStoreUrl}}">
                            <img src="/assets/img/appstore.png" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
